export default __webpack_public_path__ + "images/e4ab5704b4b3ea3acf3cd273fef4aaf2-tankBullet3.png";